@for (errorData of errors; track $index) {
  @if (control().hasError(errorData.error)) {
    <crnt-form-control-validation-message
      [wlAutomationId]="control().options.dataAutomationId + '-error'"
      [wlTrackError]="errorTrackConfig(errorData)"
      [id]="control().id + '-validation'"
    >
      {{ errorData.msg }}
    </crnt-form-control-validation-message>
  }
}
